import { AcademyMockApi } from '@fuse/mock-api/apps/academy/api';
import { ChatMockApi } from '@fuse/mock-api/apps/chat/api';
import { ContactsMockApi } from '@fuse/mock-api/apps/contacts/api';
import { ECommerceInventoryMockApi } from '@fuse/mock-api/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from '@fuse/mock-api/apps/file-manager/api';
import { HelpCenterMockApi } from '@fuse/mock-api/apps/help-center/api';
import { MailboxMockApi } from '@fuse/mock-api/apps/mailbox/api';
import { NotesMockApi } from '@fuse/mock-api/apps/notes/api';
import { ScrumboardMockApi } from '@fuse/mock-api/apps/scrumboard/api';
import { TasksMockApi } from '@fuse/mock-api/apps/tasks/api';
import { AuthMockApi } from '@fuse/mock-api/common/auth/api';
import { MessagesMockApi } from '@fuse/mock-api/common/messages/api';
import { NavigationMockApi } from '@fuse/mock-api/common/navigation/api';
import { NotificationsMockApi } from '@fuse/mock-api/common/notifications/api';
import { SearchMockApi } from '@fuse/mock-api/common/search/api';
import { ShortcutsMockApi } from '@fuse/mock-api/common/shortcuts/api';
import { UserMockApi } from '@fuse/mock-api/common/user/api';
import { AnalyticsMockApi } from '@fuse/mock-api/dashboards/analytics/api';
import { CryptoMockApi } from '@fuse/mock-api/dashboards/crypto/api';
import { FinanceMockApi } from '@fuse/mock-api/dashboards/finance/api';
import { ProjectMockApi } from '@fuse/mock-api/dashboards/project/api';
import { ActivitiesMockApi } from '@fuse/mock-api/pages/activities/api';
import { IconsMockApi } from '@fuse/mock-api/ui/icons/api';
import { CalendarMockApi } from './apps/calendar/api';

export const mockApiServices = [
  AcademyMockApi,
  ActivitiesMockApi,
  AnalyticsMockApi,
  AuthMockApi,
  ChatMockApi,
  ContactsMockApi,
  CryptoMockApi,
  ECommerceInventoryMockApi,
  FileManagerMockApi,
  FinanceMockApi,
  HelpCenterMockApi,
  IconsMockApi,
  MailboxMockApi,
  MessagesMockApi,
  NavigationMockApi,
  NotesMockApi,
  NotificationsMockApi,
  ProjectMockApi,
  SearchMockApi,
  ScrumboardMockApi,
  ShortcutsMockApi,
  TasksMockApi,
  UserMockApi,
  CalendarMockApi,
];
